// extracted by mini-css-extract-plugin
module.exports = {"pageBanners":"style_pageBanners__2Rzaf","warning":"style_warning__2ZcS-"};